export enum Layout {
  XS,
  SM,
  MD,
  LG,
  XL,
}

/**
 * Calculates which of our 'layouts' the page currently fits in.
 *
 * @param {Number} width The width to calculate the layout for.  Defaults to the window width if not provided.
 */
export function calculateLayout(width: number): Layout {
  if (width >= 1280) return Layout.XL
  if (width >= 1024) return Layout.LG
  if (width >= 768) return Layout.MD
  if (width >= 640) return Layout.SM
  return Layout.XS
}

export function isMobileLayout(width: number): boolean {
  return calculateLayout(width) <= Layout.SM
}

export function isTabletLayout(width: number): boolean {
  return calculateLayout(width) <= Layout.MD
}
